// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeFoamFree: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#fa6400", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M5.786 5.464a.32.32 0 0 0-.322.322v6.428c0 .177.145.322.322.322h6.428a.32.32 0 0 0 .322-.322V5.786a.32.32 0 0 0-.322-.322zM4.5 5.786c0-.71.577-1.286 1.286-1.286h6.428c.71 0 1.286.577 1.286 1.286v6.428c0 .71-.577 1.286-1.286 1.286H5.786c-.71 0-1.286-.577-1.286-1.286zm3.054 2.732h2.892a.481.481 0 1 1 0 .964H7.554a.481.481 0 1 1 0-.964"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeFoamFree);
